import { css } from 'styled-components';
import { BreakpointQueryName, ThemedFunctor } from '@doveit/lego';

export const base: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-wrap: wrap;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex-wrap: nowrap;
  }
`;

export const list: ThemedFunctor = ({ theme }) => css`
  flex: 1 0 100%;
  width: 100%;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex: 1 0 50%;
  }
`;
